import React, { useState } from "react";
import Header from "../../components/global/Header";
import { Spin } from "antd";
import { GoogleOutlined } from "@ant-design/icons";
import { LoadingOutlined } from "@ant-design/icons";
import { useSnackbar } from "notistack";
import { connect, useSelector } from "react-redux";
import joi from "joi";
import { loginStoreAction } from "../../redux/action/authActions";
import { Link, useHistory } from "react-router-dom";
import pic from "../../assets/images/Vector.png";

function SignIn(props) {
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  // Get loader
  const loader = useSelector((state) => state.auth.isLoading);

  // User Input details
  const [state, setState] = useState({
    email: "",
    password: "",
  });

  const { email, password } = state;

  const validateUserLogin = (data) => {
    const signinSchema = joi.object({
      email: joi
        .string()
        .required()
        .email({ tlds: { allow: false } }),
      password: joi.string().min(6).required(),
    });
    return signinSchema.validate(data);
  };

  function handleChange(e) {
    const { name, value } = e.target;
    setState({
      ...state,
      [name]: value,
    });
  }

  function handleOnSubmit(e) {
    e.preventDefault();
    const { error } = validateUserLogin(state);
    if (error) {
      const details = error.details[0].message.split(": ")[0];
      enqueueSnackbar(details, {
        variant: "warning",
        vertical: "top",
        horizontal: "right",
      });
    } else {
      props.loginStoreAction(state).then((res) => {
        if (res.status) {
          enqueueSnackbar(res?.message || "Login Successful", {
            variant: "success",
            vertical: "top",
            horizontal: "right",
          });
          // Clear the input field
          setState({
            email: "",
            password: "",
          });
          setTimeout(() => {
            history.push("/user-home");
          }, 2000);
        } else {
          enqueueSnackbar(res?.message || "OOps, Something went wrong", {
            variant: "error",
            vertical: "top",
            horizontal: "right",
          });
        }
      });
    }
  }

  return (
    <div>
      <Header />
      <div className="signUp">
        <div className="signUp__container">
          <p className="signUp__title">
            {" "}
            <img src={pic} alt="" /> Pharmacy
          </p>
          <p className="signUp__subtitle">WELCOME BACK</p>
          <span className="signUp__text">
            Sign in to continue from
            <br /> where you stopped
          </span>
          <form autoComplete="true" onSubmit={handleOnSubmit}>
            <input
              type="text"
              placeholder="email@example.com"
              autoFocus={true}
              name="email"
              value={email}
              id="email"
              onChange={handleChange}
            />
            <br />
            <input
              type="password"
              placeholder="Password"
              autoComplete="false"
              name="password"
              value={password}
              id="password"
              onChange={handleChange}
            />
            <br />

            <button disabled={loader}>
              {loader ? <Spin indicator={antIcon} /> : "Sign In"}{" "}
            </button>
          </form>
          <button className="google-signup-button">
            <GoogleOutlined style={{ fontSize: "25px", marginRight: "10px" }} />{" "}
            Continue with Google
          </button>

          
          <div className="auth">
            <p>Don't have an account ? <span className="auth-p"><Link to="/registerphm"> Create an account</Link></span></p>
            <p>Forgot Password? <span className="auth-p"><Link to="/store/forgot-password"> Reset Password</Link></span></p>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    loginStoreAction: (payload) => dispatch(loginStoreAction(payload)),
  };
};

export default connect(null, mapDispatchToProps)(SignIn);
